<template>
    <div class="main-nav">
        <nav class="navbar navbar-expand topbar static-top shadow" :class="navbarClass">
            <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
                <i class="fa fa-bars"></i>
            </button>
            <ul v-if="!isAdmin && cgaStatus" class="navbar-nav mr-auto">
                <li class="nav-added-btn-li px-2 li-left">
                    <cga-control-heading />
                </li>
            </ul>
            <ul class="navbar-nav ml-auto">
                <li v-if="!isAdmin && cgaStatus" class="nav-added-btn-li px-2">
                    <router-link to="/common-sense" class="link">{{$t('COMMON_SENSE')}}</router-link>
                </li>
                <li v-if="!isAdmin && cgaStatus" class="nav-added-btn-li px-2">
                    <router-link to="/summary" class="link">{{$t('SUMMARY')}}</router-link>
                </li>
                <li class="topbar-divider d-sm-block"></li>
                <li class="d-flex" v-if="isAdmin">
                    <span class="my-auto">You are now modifying CGA in</span>
                </li>
                <li class="nav-item dropdown no-arrow mx-1" v-if="selectedLanguage != null && (!cgaStatus || isAdmin)">
                    <a class="nav-link dropdown-toggle" href="#" id="languageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="dropdown-list-image mr-3">
                            <img class="img-profile rounded-circle" :src="selectedLanguage.flagImagePath" :alt="selectedLanguage.longTitle">
                        </div>
                        <div>
                            <div class="text-truncate">{{selectedLanguage.longTitle}}</div>
                        </div>
                    </a>
                    <div id="language-dropdown-items-container" class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="languageDropdown">
                        <h6 class="dropdown-header">
                            {{$t('SELECT_LANGUAGE')}}
                        </h6>
                        <button v-for="(language, index) in languages" :key="index" class="dropdown-item d-flex align-items-center language-dropdown-item" @click="selectLanguage(language)">
                            <div class="dropdown-list-image mr-3">
                                <img class="rounded-circle" :src="language.flagImagePath" :alt="language.longTitle">
                            </div>
                            <div :class="{ 'font-weight-bold' : language == selectedLanguage }">
                                <div class="text-truncate">{{language.longTitle}}</div>
                            </div>
                        </button>
                    </div>
                </li>
                <li class="topbar-divider d-none d-sm-block"></li>
                <li class="nav-item dropdown no-arrow">
                    <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{userFirstName}} {{userLastName}}</span>
                        <icon icon="user-circle" />
                    </a>
                    <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                        <router-link class="dropdown-item" :to="profileInfoRoute">{{$t('PROFILE')}}</router-link>
                        <router-link class="dropdown-item" :to="profileSettingsRoute">{{$t('SETTINGS')}}</router-link>
                        <div class="dropdown-divider"></div>
                        <button class="dropdown-item" @click="showLogoutModal = true">{{$t('LOGOUT')}}</button>
                    </div>
                    <modal :title="logoutModalTitle" :body="logoutModalBody" :button="logoutModalButtonText" @action="logout" v-if="showLogoutModal" @close="showLogoutModal = false"></modal>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
import Modal from './../../misc/Modal.vue';
import CgaControlHeading from './../../pages/partials/CgaControlHeading'

    export default {
        components: {
            modal: Modal,
            CgaControlHeading
        },
        props: {
            navbarClass: [String],
            profileInfoRoute: [String],
            profileSettingsRoute: [String]
        },
        data() {
            return {
                userFirstName: '',
                userLastName: '',
                showLogoutModal: false,
                emptyCgaPatient: {
                    firstName: '',
                    lastName: ''
                }
            }
        },
        computed: {
            logoutModalTitle() {
                return this.$t('LOGOUT_CONFIRMATION')
            },
            logoutModalBody() {
                return this.$t('LOGOUT_CONFIRMATION_MESSAGE')
            },
            logoutModalButtonText() {
                return this.$t('LOGOUT')
            },
            isAdmin() {
                return this.$store.getters.isAdmin;
            },
            cgaStatus() {
                return this.$store.getters.cgaStatus;
            },
            cgaPatient() {
                return this.$store.getters.cgaPatient || this.emptyCgaPatient;
            },
            selectedLanguage() {
                return this.$store.getters.selectedLanguage || null;
            },
            languages() {
                return this.$store.getters.systemLanguages || [];
            }
        },
        methods: {
            selectLanguage: function (language) {
                this.$store.dispatch('selectLanguage', language);
            },
            loadSystemLanguages: function () {
                if (!this.cgaStatus) {
                    this.$store.dispatch('loadSystemLanguages')
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error);
                    })
                }
            },
            logout: function () {
                let self = this;
                this.$store.dispatch('destroyTokens')
                    .then(response => {
                        self.$router.push({ name: 'login' });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            loadDoctorInformation: function(doctorId) {
                let self = this;
                this.$http.get("/api/doctor/profile")
                    .then(response =>
                    {
                        self.userFirstName = response.data.firstName;
                        self.userLastName = response.data.lastName;
                        // self.selectLanguage(response.data.language);
                    })
                    .catch();
            },
            // loadUserNames: function () {
            //     let self = this;
            //     this.$http.get("/api/users/current")
            //         .then(response => {
            //             self.userFirstName = response.data.firstName;
            //             self.userLastName = response.data.lastName;
            //         })
            //         .catch(error => {

            //         });
            // },
        },

        mounted: function () {
            this.loadSystemLanguages();
            this.loadDoctorInformation();
        }
    }</script>
<style lang="scss" scoped >
    #languageDropdown {
        color: #39566e;
        .rounded-circle {
           height: 1.7rem;
           width: 1.7rem;
           box-shadow: 0px 0px 1px #b7b9cc;
        }
    }

    #language-dropdown-items-container {
        width: auto !important;
    }

    .language-dropdown-item {
        .rounded-circle {
           box-shadow: 0px 0px 1px #b7b9cc;
        }
    }

    .nav-added-btn-li {
        padding-top: 20px !important;
        &.li-left {
            padding-top: 0px !important;
        }
    }

    .main-nav {
        background: white;
        .navbar {
            background: white !important;
        }
    }
    #userDropdown {
        font-size: 18px;
        color: #39566e;
    }
    #feedback-btn:focus {
        text-decoration: none;
    }
    .link {
        font-size: 1.3em;
    }
</style>
